import type { PurchaseLicenseModalData } from '~/types/licenses/licenses';

export function useSubscriptionHelper() {
  function subscribe(data: PurchaseLicenseModalData) {
    const { openPurchaseModal } = useLicensePurchase();
    openPurchaseModal(data);
  }

  return {
    subscribe,
  };
} 